import * as ActionTypes from "../../app/ActionTypes";

import * as Services from "../../webAPI/MKSService";

export function addRightsRequest(projectId, roles, lockings) {
	return function (dispatch) {
		const rolesIds = roles.map(role => role.role_id);
		const lockingsIds = lockings.map(locking => locking.locking_id);
		dispatch({
			type: ActionTypes.ADD_RIGHT_REQUEST,
			rolesIds,
			lockingsIds
		});

		return Services.addRights(
			projectId,
			rolesIds,
			lockingsIds).then(
			(error) => {
				// TODO: handle error
			},
			(result) => {
				dispatch({
					type: ActionTypes.ADD_RIGHT_SUCCESS
				});
			}
		);
	};
}

export function deleteRightsRequest(projectId, roles, lockings) {
	return function (dispatch) {
		const rolesIds = roles.map(role => role.role_id);
		const lockingsIds = lockings.map(locking => locking.locking_id);
		dispatch({
			type: ActionTypes.DELETE_RIGHT_REQUEST,
			rolesIds,
			lockingsIds
		});

		return Services.deleteRights(
			projectId,
			rolesIds,
			lockingsIds).then(
			(error) => {
				// TODO: handle error
			},
			(result) => {
				dispatch({
					type: ActionTypes.DELETE_RIGHT_SUCCESS
				});
			}
		);
	};
}



// WEBPACK FOOTER //
// ./src/js/plan/rights/rightsActions.js